import DataProvider from './DataProvider';


type AuthData = {
    login: String,
    password: String,
    accountType: "USER"|"BACKOFFICE_USER"
}

class Auth {

    private static logoutHandlers: Function[] = [];

    public static async login(req: AuthData) {

        const res = await DataProvider.executeAction('auth', 'login', req)
        localStorage.setItem('sessionKey', res.result.sessionKey);

    }

    public static async initSession(sessionKey?: string) {
        if (!sessionKey) {
            sessionKey = localStorage.getItem("sessionKey") || undefined;
        }
        
        let response = await DataProvider.executeAction('auth', 'checkUserSession', sessionKey);
        localStorage.setItem('sessionKey', sessionKey || '');
        return response.result == true;
    }

    public static async logout() {
        await DataProvider.executeAction('auth', 'logout', undefined);
        localStorage.removeItem('sessionKey');
        this.logoutHandlers.forEach(handler => handler());
    }

    public static onLogout(handler: Function) {
        this.logoutHandlers.push(handler);
    }

    public static getSessionKey(): string {
        return localStorage.getItem('sessionKey') || '';
    }
}

export default Auth;